import { useEffect, useState } from "react";
import moment from "moment";

import { Form, Dropdown, Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";
import { success, error } from "../../hooks/global/ToastAlert";
import { useSentInvitations } from "../../hooks/invitations/Invitations";
import LoadingSpinner from "../global/LoadingSpinner";
import { getObjectValue } from "../../helpers/general";
import { useSelectLanguage } from "../../hooks/global/Languages";

function SingleManualInvitations({ vendor, lng, vendorLanguages, profiles, groups, products, vendorId }) {

  const { t, i18n } = useTranslation();
  const { mutate: sendInvitations, isLoading: isSending, isError: isUpdateError, data:result } = useSentInvitations();

  const [groupsVisible, setGroupsVisible] = useState(false);
  const [reviewProfileVisible, setReviewsProfileVisible] = useState(false);
  const [reviewProfile, setReviewProfile] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState();
  const [openedGroups, setOpenedGroups] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [timeToSend, setTimeToSend] = useState(0);
  const [checkedReviewProfile, setCheckedReviewProfile] = useState();
  const [inputError, setInputError] = useState();

  const validateRules = [
    { index: 'firstName', regex: /^.+$/s },
    { index: 'lastName', regex: /^.+$/s },
    { index: 'email', regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ }
  ];


  const { selectTextByLanguage } = useSelectLanguage();

  useEffect(() => {
    if (vendorLanguages.length > 0) {
      setSelectedLanguage(vendorLanguages[0]);
    }
  }, [vendorLanguages]);

  const toggleSelectedProduct = (productId) => {
    if (selectedProducts.includes(productId)) {
      let newArray = [...selectedProducts];
      let index = newArray.indexOf(productId);
      if (index !== -1) {
        newArray.splice(index, 1);
        setSelectedProducts(newArray);
      }
    } else {
      setSelectedProducts((selectedProducts) => [
        ...selectedProducts,
        productId,
      ]);
    }
  };

  const resetFormOnSuccess = () => {
    setReviewsProfileVisible(false);
    setReviewProfile(false);
    setGroupsVisible(false);
    setOpenedGroups([]);
    setSelectedProducts([]);
  };

  const validateInvitation = () => {
    let err = {};
    let atLeastOneSelected = reviewProfile || selectedProducts.length > 0;


    validateRules.forEach(item => {
      const value = getObjectValue({ firstName: firstName, lastName: lastName, email: email }, item.index)
      if (!item.regex.test(value))
        err[item.index] = true;
    });

    setInputError(err);

    if (atLeastOneSelected && Object.keys(err).length === 0) {
      return true;
    } else {
      Object.keys(err).length>0 ?   error(t("err.sInv")):error(t("toast.one"));
      return false;
    }
  };

  const profileSelectTitle = () => {
    let profile = profiles.find((p) => p.id === selectedProfileId);
    return profile ? profile.name : t("admin.inv.chUn");
  };

  const removeProfileToReview = () => {
    setSelectedProfileId(undefined);
    setReviewProfile(false);
  };

  const selectProfileToReview = (profileId) => {
    setSelectedProfileId(profileId);
    setReviewProfile(true);
  };

  const toggleOpenedGroup = (groupId) => {
    if (openedGroups.includes(groupId)) {
      let newArray = [...openedGroups];
      let index = newArray.indexOf(groupId);
      if (index !== -1) {
        newArray.splice(index, 1);
        setOpenedGroups(newArray);
      }
    } else {
      setOpenedGroups((openedGroups) => [...openedGroups, groupId]);
    }
  };

  const groupsHaveProducts = () => {
    let haveProducts = false;

    if (groups.length > 0 && products.length > 0) {
      products
        .filter((product) => product.group_id)
        .map((product) => {
          if (groups.find((group) => product.group_id === group.id)) {
            haveProducts = true;
          }
        });
    }

    return haveProducts || (profiles && profiles.length > 1);
  };

  const showGroups = () => {
    //setReviewProfile(!reviewProfile);
    setGroupsVisible(true);
  };

  const hideGroups = () => {
    // setReviewProfile(!reviewProfile);
    setGroupsVisible(false);
  };

  const submitInvitation = (e) => {
    e.preventDefault();
    if (validateInvitation()) {
      let payload = {
        customerEmail: email,
        customerName: firstName,
        customerSurname: lastName,
        orderNumber: orderNumber,
        vendorId: vendorId,
        reviewProfile: reviewProfile,
        purchaseDateUtcMs: moment().format("x"),
        sendAfterHours: timeToSend,
        sendProductReviewAfterHours: timeToSend,
        language: selectedLanguage,
        products: [],
      };

      if (reviewProfile) {
        payload.profileId = selectedProfileId ? selectedProfileId : profiles[0].id;
      }

      if (products) {
        products.filter((product) => selectedProducts.includes(product.id)).map((product) => {
            let productPayload = {
              sourceId: product.source_id,
              name: product.name,
              imgUrl: product.imgUrl,
              group: groups.filter((group) => group.id === product.group_id)[0]
                .name,
              tags: product.tags,
              nameMultilanguage: product.name,
            };
            payload.products.push(productPayload);
          });
      }

      sendInvitations({ data: payload, message: t("toast.inv"), show:false });
      resetFormOnSuccess();
    }
  };

  if(result && (result?.result?.[0].status ==='sent' || result?.result?.[0].status ==='scheduled')){
    success(t("toast.inv"));
    result.result = null;
  } else if(result && result?.result?.[0].status ==='error'){

    if(result.result[0]?.t)
      error(t(result.result[0].t));
    else
      error(t("err.sInv") + ': ' + result.result[0].reject_reason);

    result.result = null;
  }

  return (
    <div>
      {
        <>
          <h2>
            {t("admin.inv.data")}
            <span className="mail"></span>
          </h2>
          <Form className="manualInvite clearfix">
            <div className="row">
              <Form.Group className={`editMe-field editMe-fieldName ${inputError?.firstName ? "has-error has-feedback" : ""}`} controlId="fromBasicName" >
                <Form.Control
                  name="name"
                  placeholder={t("admin.prize.name")}
                  tabIndex="1"
                  value={firstName}
                  type="text"
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {inputError?.firstName && <span className="help-block validation-message small">{t('err.req')}</span>}
              </Form.Group>
              <Form.Group className={`editMe-field editMe-fieldLastName ${inputError?.lastName ? "has-error has-feedback" : ""}`}
                controlId="fromBasicLastName"
              >
                <Form.Control
                  name="surname"
                  placeholder={t("admin.prize.lastname")}
                  tabIndex="2"
                  value={lastName}
                  type="text"
                  onChange={(e) => setLastName(e.target.value)}
                />
                {inputError?.lastName && <span className="help-block validation-message small">{t('err.req')}</span>}
              </Form.Group>
            </div>
            <Form.Group className={`editMe-field editMe-fieldEmail ${inputError?.email ? "has-error has-feedback" : ""}`} controlId="formBasicEmail">
              <Form.Control
                name="email"
                placeholder={t("login.email")}
                tabIndex="3"
                value={email}
                type="email"
                onChange={(e) => setEmail(e.target.value)}
              />
              {inputError?.lastName && <span className="help-block validation-message small">{t('err.req')}</span>}
            </Form.Group>
            <Form.Group
              className="editMe-field editMe-fieldOrder"
              controlId="formBasicordernumber"
            >
              <Form.Control
                name="orderNumber"
                placeholder={t("admin.inv.num")}
                value={orderNumber}
                tabIndex="4"
                type="text"
                onChange={(e) => setOrderNumber(e.target.value)}
              />
            </Form.Group>

            {groupsVisible && profiles && profiles.length > 0 && (
              <div className="manualInvite-product">
                <h6>{t("admin.inv.reFi")}</h6>
                <div>
                  <div className={ reviewProfileVisible ? "elements open" : "elements"}>
                    <h4 onClick={() => setReviewsProfileVisible(!reviewProfileVisible)}>
                      {t("admin.common.exp")}
                    </h4>

                    {(reviewProfileVisible || reviewProfile) && (
                    
                      <div>
                        {profiles.length > 1 ? (
                          <div className="dropdownWrap">
                                                  <Dropdown>
                        <Dropdown.Toggle variant="default" id="selectProfileDropdown">
                          {profileSelectTitle()}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() => removeProfileToReview()}>
                            {t("admin.inv.re")}
                          </Dropdown.Item>
                          {profiles.map((profile, key) => (
                            <Dropdown.Item
                              key={key}
                              eventKey={profile.id}
                              onClick={() => selectProfileToReview(profile.id)}
                            >
                              {profile.name}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                          </div>
                        ) : (
                          <div
                            className={
                              reviewProfile
                                ? "element pb-3 selected clearfix profilePicker"
                                : "element pb-3 clearfix profilePicker"
                            }
                            onClick={() => setReviewProfile(!reviewProfile)}
                          >
                            <Form.Check
                              className="checkbox"
                              type="checkbox"
                              name="reviewProfile"
                              tabIndex="5"
                              checked={reviewProfile}
                              onChange={(e) =>
                                setCheckedReviewProfile(e.target.value)
                              }
                            />

                            <span className="checkboxLabel">
                              {t("admin.inv.ni")}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                {groups &&
                  groups.map((group, key) => {
                    return (
                      <div key={key}>
                        {products &&
                          products.filter((product) => product.group_id === group.id).length > 0 && (
                            <div className={"elements " + (openedGroups.includes(group.id) ? "open" : "")}>
                              <h4 onClick={() => toggleOpenedGroup(group.id)}>
                                {selectTextByLanguage(group.nametoshow)}
                              </h4>
                              <div className="clearfix maxHeight">
                                {products.filter((product) =>product.group_id === group.id &&(openedGroups.includes(group.id) || selectedProducts.includes(product.id)))
                                  .map((product, key) => {
                                    return (
                                      <div className={"element pb-3 " + (selectedProducts.includes(product.id) ? "selected": "")} key={key} onClick={() => toggleSelectedProduct(product.id) }>
                                        <Form.Check className="checkbox"
                                          type="checkbox"
                                          name={"selected" + product.id}
                                          checked={selectedProducts.includes(product.id)}
                                          onChange={(e) => { }}
                                        />

                                        <span className="checkboxLabel">
                                          {selectTextByLanguage(product.name)}
                                        </span>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          )}
                      </div>
                    );
                  })}
              </div>
            )}
            <div className="clearfix">

              {!groupsVisible && (
                <p>
                  <a onClick={showGroups} className="link link-addElement" title={t("admin.group.addE")}>
                    {t("admin.inv.addA")}
                  </a>
                </p>
              )}
            </div>
            <div className="editMe-field editMe-fieldOrder editMe-fieldOrderRight">
              {vendorLanguages.length > 1 && <h6>{t("admin.inv.invLng")}</h6>}
              {vendorLanguages.length > 1 &&
                vendorLanguages.map((lng) => {
                  return (
                    <div className="langSelectInvWrap" key={lng}>
                      <Form.Control
                        id={"langSelectInv" + lng}
                        type="checkbox"
                        name="language"
                        checked={selectedLanguage === lng}
                        value={lng}
                        onChange={(e) => setSelectedLanguage(e.target.value)}
                      />
                      <label htmlFor={"langSelectInv" + lng}>{lng}</label>
                    </div>
                  );
                })}
            </div>
            <div className="margin-top-30 clearfix">
              <div className="delayWrap clearfix">
                <h6>{t("admin.inv.time")}</h6>
                <div className="delay">
                  <p>{t("admin.inv.getIn")}</p>
                  <div className="form-group row">
                    <div className="col-sm-9">
                      <Form.Control
                        type="number"
                        name="invitationDelay"
                        value={timeToSend}
                        onChange={(e) => setTimeToSend(e.target.value)}
                      />
                    </div></div>
                  <span>{t("admin.inv.h")}.</span>
                </div>
              </div>
              <div className="text-center">
                {!isSending ? (<Button type="submit" className="btn btn-default btn-send" title={t("common.send")} onClick={(e) => submitInvitation(e)} >
                  {t("common.send")}
                </Button>) : (<LoadingSpinner style={{ margin: '25px auto 15px' }} />)}
              </div>
            </div>
          </Form>
        </>
      }
    </div>
  );
}
export default SingleManualInvitations;
